module.exports = __webpack_public_path__ + "img/DieDrachen.4f9c5cea.jpg";